export default class ClearLookupApi {
  constructor(context) {
    this.context = context;
  }

  run() {
    if (this.context.stores.appFeatures.get().isEnabled('integrationsManagement')) {
      this.context.stores.lookupApiConfig.remove();
      this.context.gateways.customerLookupConfiguration.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/integrations/clear_lookup_api.js